import { credentialTypeHref } from "../../utils/constants";

export const baseUrl = credentialTypeHref;
export const port = process.env.REACT_APP_PORT || "3000";
export const localHost = `http://localhost:${port}`;
